<script setup>
import {ref, inject, watch, onMounted} from "vue";
import PrimaryButton from "@/components/ui/PrimaryButton.vue";
import StartupsSelector from "@/components/ui/StartupsSelector.vue";
import marketsService from "@/services/markets.service";

const selectedStartups = inject('selectedStartups');
const showModal = ref(false);

const startups = ref([]);
const defaultList = ref([]);

watch(selectedStartups, (value) => {
    startups.value = value;
}, {immediate: true});

onMounted(() => {
    getDefaultList();
});

async function getDefaultList() {
    const {data} = await marketsService.getMostFrequentStartupsList();

    defaultList.value = data;
}

function apply() {
    selectedStartups.value = startups.value;
    showModal.value = false;
}

function open() {
    showModal.value = true;
}

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" title="Select Startups">
        <StartupsSelector
            v-model="startups"
            :default-list="defaultList"
            filter="partnerships"
            multiple
        />

        <template #modal-footer>
            <PrimaryButton
                caption="Apply"
                @click="apply"
            />
        </template>
    </b-modal>
</template>

<style scoped>

</style>
